import React, { useCallback, useContext, useState } from "react";
import styled from "styled-components";
import TextField from "../Common/TextField";
import womanDoctor from "../../SVGs/womanDoctor.svg";
import CustomButton from "../Common/CustomButton";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../server/get_api_client";
import { useLocation, useNavigate } from "react-router-dom";
import RequireLogout from "../../permissions.js/RequireLogout";
import Footer from "../Common/Footer";
import Nav from "../Common/Nav";
import toast from "react-hot-toast";
import PageLoader from "../Common/PageLoader";

function ForgetPassword() {
  const navigation = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [strength, setStrength] = useState(0);
  const [passwordError, setPasswordError] = useState("");
  const [passwordRequirements, setPasswordRequirements] = useState({
    minLength: false,
    uppercase: false,
    specialChar: false,
  });

  const location = useLocation();

  const validatePassword = (password) => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{8,}$/;
    return passwordRegex.test(password);
  };

  const evaluateStrength = (password) => {
    let score = 0;
    const requirements = { ...passwordRequirements };

    if (password.length >= 8) {
      score += 25;
      requirements.minLength = true;
    } else {
      requirements.minLength = false;
    }
    if (/[A-Z]/.test(password) && /[a-z]/.test(password)) {
      score += 50;
      requirements.uppercase = true;
    } else {
      requirements.uppercase = false;
    }


    if (/[@$!%*?&]/.test(password)) {
      score += 25;
      requirements.specialChar = true;
    } else {
      requirements.specialChar = false;
    }

    setStrength(score);
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    evaluateStrength(value);
    setPasswordError("");
  };

  const handleVerifyPasswordChange = (value) => {
    setVerifyPassword(value);
    setPasswordError("");
  };

  const Submit = useCallback(() => {
    if (!validatePassword(password)) {
      setPasswordError("Ensure the password meets the requirements.");
      return;
    }

    if (verifyPassword !== password) {
      setPasswordError("Passwords do not match.");
      return;
    }

    setIsLoading(true);
    getApiClient()
      .ForgetPassword({
        username: location.state.username,
        newPassword: password,
        otpCode: location.state.code,
      })
      .then((res) => {
        if (res) {
          navigation("/login", {
            state: {
              message:
                "Password changed successfully. Please log in to continue.",
            },
          });
        }
        window.location.reload();
      })
      .catch(makeStandardApiErrorHandler((error) => toast.error(error)))
  });

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <InnerContainer>
          <LeftContaienr>
            <LeftContaienrBanner><Title>Reset Password</Title></LeftContaienrBanner>
            <LeftContaienrContent>

              <Text>Set up your new password:</Text>
              <FieldsContainer>
                <TextField
                  title={"*Password"}
                  direction={"column"}
                  type={"password"}
                  width={"300px"}
                  value={password}
                  setValue={handlePasswordChange}
                />
                <TextField
                  title={"*Verify Password"}
                  direction={"column"}
                  type={"password"}
                  width={"300px"}
                  value={verifyPassword}
                  setValue={handleVerifyPasswordChange}
                />
                {passwordError && <ErrorMessage>{passwordError}</ErrorMessage>}
                <PasswordRequirements requirements={passwordRequirements} />
                <PasswordStrengthBar strength={strength} />
              </FieldsContainer>
              <ButtonContainer>
                <CustomButton handle={Submit} title="Change Password" />
              </ButtonContainer>
            </LeftContaienrContent>

          </LeftContaienr>
        </InnerContainer>
      </Container>
      <Footer />
    </>
  );
}

const PasswordRequirements = ({ requirements }) => {
  return (
    <Requirements>
      <Requirement>
        {requirements.uppercase ? "✔️" : "❌"} At least one uppercase letter, one lowercase letter.
      </Requirement>
      <Requirement>
        {requirements.specialChar ? "✔️" : "❌"} At least one special character
        from @$!%*?&.
      </Requirement>
      <Requirement>
        {requirements.minLength ? "✔️" : "❌"} A minimum of 8 characters in
        total.
      </Requirement>
    </Requirements>
  );
};

const PasswordStrengthBar = ({ strength }) => {
  const getColor = (score) => {
    if (score <= 25) return "#FF0000"; // Weak
    if (score <= 50) return "#FFA500"; // Moderate
    if (score <= 75) return "#FFFF00"; // Good
    return "#008000"; // Strong
  };

  return (
    <ProgressBar>
      <Progress
        style={{ width: `${strength}%`, backgroundColor: getColor(strength) }}
      />
    </ProgressBar>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 95vh;
`;

const Requirements = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Requirement = styled.div`
  font-family: "Museo Sans Cyrl";
  font-size: 14px;
  color: #304961;
`;

const LeftContaienr = styled.div`
  display: flex;
  flex-direction: column;
  width: 30vw;
  min-width: 300px;
    border-radius: 20px;
  gap: 2vh;
  border-radius: 20px;
  background: #ecf3fb;
  

`;
const LeftContaienrBanner = styled.div`
display:flex;
width:auto;
background-color:#304961;
min-height:2vh;
padding:8%;
border-radius: 20px 20px 0 0;
align-items: center;
justify-content: center;
  box-shadow:0px 0px 10px #304961;


`;
const LeftContaienrContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  width: auto;
  gap: 2vh;
  background: #ecf3fb;
  padding:2%;
  border-radius:20px;

  @media screen and (max-width: 662px) {
    gap: 20px;
    padding: 20px 10px;
  }
`;

const InnerContainer = styled.div`
  padding: 100px 100px;

  min-height: 95vh;
  width: 90vw;
  border-radius: 30px;

  background-image: url(${womanDoctor});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: local;

  @media screen and (max-width: 662px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 10px;
  background-color: #e0e0e0;
  border-radius: 5px;
  margin-top: 10px;
  overflow: hidden;
`;

const Progress = styled.div`
  height: 100%;
  transition: width 0.3s;
`;

const Title = styled.p`
  margin-bottom: 20px;
  color: var(--white);
font-family: 'Georgia';
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 90%;
  letter-spacing: 1px;
  white-space: wrap;
  text-transform: uppercase;


`;

const Text = styled.p`
  width: 80%;
  color: var(--darkBlue);

  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 120% */
`;

const FieldsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`;

const ErrorMessage = styled.div`
  color: #ff0000;
  font-size: 12px;
  width: 100%;
  margin-top: 4px;
  font-family: "Museo Sans Cyrl";
`;

export default RequireLogout(ForgetPassword);
